module.exports = __webpack_public_path__ + "img/defaultprofile.d4b45420.jpg";